import { Button } from '../Button';

import { iconButtonVariants } from './iconButtonVariants';

import type { ButtonProps } from '../Button';

export type IconButtonProps = Omit<ButtonProps, 'fullWidth' | 'size'> & {
  children: React.ReactNode;
  size?: Exclude<ButtonProps['size'], 'middle' | 'tiny'>;
};

export const IconButton = ({ children, className, size = 'default', ...props }: IconButtonProps) => (
  <Button className={iconButtonVariants({ className, size })} size={size} {...props}>
    {children}
  </Button>
);
